'use client';

import { useAppState } from './AppStateContext';
import { usePathname } from 'next/navigation';
import { FunctionComponent } from 'react';

export const MatildaLauncher: FunctionComponent = () => {
  const pathname = usePathname();
  const { chatOpen, setChatOpen } = useAppState();

  if (!isGeneralRoute(pathname)) return null;

  return (
    <div className="fixed bottom-[22px] right-[22px] z-[31] flex items-center gap-2.5" hidden={chatOpen}>
      <button
        type="button"
        className="inline-flex h-[42px] w-[42px] cursor-pointer items-center justify-center rounded-full border-none bg-ink text-white shadow-[0_6px_18px_rgba(0,0,0,0.18)] transition-[background-color,transform] duration-150 hover:-translate-y-px hover:bg-acc"
        onClick={() => setChatOpen(true)}
        aria-label="Chat with Matilda"
        title="Chat with Matilda"
      >
        <ChatGlyph />
      </button>
    </div>
  );
};

const ChatGlyph: FunctionComponent = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

function isGeneralRoute(pathname: string | null): boolean {
  if (!pathname) return true;
  if (pathname.startsWith('/sponsor/')) return false;
  if (pathname.startsWith('/onboarding/client/')) return false;
  if (pathname.startsWith('/ftw/recording/')) return false;
  if (pathname.startsWith('/computer-use/recording/')) return false;
  return true;
}
